module.exports = __webpack_public_path__ + "img/logo.6452f7a1.png";